export const site = {
  name: "InvoiceVault",
  /** Customer-facing brand (Marketplace, UI, footer, support). */
  brandName: "QiQi Forge",
  /** Legal entity — contracts, Stripe platform account (not shown in UI by default). */
  companyName: "QiQi AI Studio L.L.C.",
  supportEmail: "help@qiqiforge.io",
  legalEffectiveDate: "June 25, 2026",
  /** Canonical legal page (Privacy & Terms). */
  appHost: "https://app.qiqiforge.io",
  legalUrl: "https://app.qiqiforge.io/legal",
  legalPrivacyUrl: "https://app.qiqiforge.io/privacy",
  legalTermsUrl: "https://app.qiqiforge.io/terms",
  docsUrl: "https://app.qiqiforge.io/docs",
  marketingHost: "https://qiqiforge.io",
  stripeDashboardUrl: "https://dashboard.stripe.com",
  /** Stripe App Marketplace listing (direct URL — do not use /search; indexing can lag or fail). */
  stripeMarketplaceUrl: "https://marketplace.stripe.com/apps/bulk-invoice-vault",
  /** Align with invoice-servers `session-ttl-hours`. */
  sessionTtlHours: 48,
} as const;
